var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFahuoguanli = function SvgFahuoguanli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.702%",
    id: "fahuoguanli_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A5F0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#fahuoguanli_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.73 14.028v3.361a.166.166 0 0 0 .27.131l2.659-2.079a.554.554 0 0 1 .682 0l2.66 2.08a.166.166 0 0 0 .268-.132v-3.361l5.23-.001v7.393c0 .663-.586 1.202-1.307 1.202H8.808c-.722 0-1.308-.54-1.308-1.202v-7.392h5.23ZM17.833 9.4c.071 0 .13.091.13.203v5.306a.166.166 0 0 1-.292.11l-1.254-1.429a.554.554 0 0 0-.832 0l-1.255 1.429a.166.166 0 0 1-.29-.11V9.603c0-.112.058-.203.129-.203Zm-5.102 0v3.306H7.5V10.6c0-.663.586-1.201 1.308-1.201h3.922Zm10.462 0c.721 0 1.308.538 1.308 1.201l-.001 2.104h-5.23V9.4h3.923Z",
    fill: "#FFF"
  }))));
};

export default SvgFahuoguanli;